import { djangoErrorHandler } from '@/helpers'
import { BUSINESS_PYTHON } from '@/clients'

const fetchBusinessUser = async => {
  const route = '/users/me/'
  return BUSINESS_PYTHON.get(route)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(djangoErrorHandler(error)))
}

export { fetchBusinessUser }
